import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/query-client";
import { parseSearch, stringifySearch } from "./lib/search-codec";
import { NotFound } from "./components/not-found";

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TanStack Router pattern: context is provided at render time via RouterProvider
    auth: undefined!,
  },
  // Every unmatched path — a mistyped URL, a stale bookmark, a link from an
  // older build — lands on the design-system page instead of the router's bare
  // "Not Found" string.
  defaultNotFoundComponent: NotFound,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  // Every search param is the exact string the URL carried (see the codec's
  // doc): the default JSON reading drops a letter code that looks like a number.
  parseSearch,
  stringifySearch,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
